@let view = data();

<div class="buttons">
  @for (button of view.buttons; track button) {
    <a
      class="button-item"
      [link]="button.link"
      matButton="filled"
      uiContentLink
    >
      @if (view.faIcon; as faIcon) {
        <ui-icon
          [faName]="faIcon.name"
          [faStyle]="faIcon.style"
          matButtonIcon
        />
      }
      {{ button.link.label }}
    </a>
  }
</div>
